import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import "./index.scss";
import TopNav from "views/Components/SuperAdmin/Navbars/TopNav/index";
import Sidenav from "views/Components/SuperAdmin/Navbars/Sidebar/index";
import { API_BASE_URL } from "constants/index";

const tableStyles = {
  headCells: {
    style: {
      fontWeight: "600",
      fontSize: "1.4rem",
      textTransform: "capitalize",
      paddingLeft: "1rem",
      paddingRight: "1rem",
    },
  },
  cells: { style: { paddingLeft: "1rem", paddingRight: "1rem" } },
  rows: { style: { minHeight: "5.2rem" } },
};

const columns = [
  { name: "Type", selector: (otp) => otp.otp_type, sortable: true },
  {
    name: "Recipient",
    selector: (otp) => otp.email,
    sortable: true,
    grow: 2,
    cell: (otp) => (
      <div className="otp-history__recipient">
        {otp.name && <strong>{otp.name}</strong>}
        <span>{otp.email}</span>
      </div>
    ),
  },
  {
    name: "OTP",
    selector: (otp) => otp.otp,
    sortable: true,
    cell: (otp) => <code className="otp-history__code">{otp.otp}</code>,
  },
  { name: "Sent", selector: (otp) => otp.created_on, sortable: true },
];

const getAuthConfig = () => ({
  headers: { Authorization: `Bearer ${localStorage.token}` },
});

const OtpHistory = () => {
  const [otps, setOtps] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState("");
  const loadOtps = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/admin/otps`,
        getAuthConfig(),
      );
      setOtps(response.data?.data || []);
    } catch (error) {
      setMessage(
        error?.response?.data?.message || "Unable to load recent OTPs.",
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadOtps();
  }, [loadOtps]);

  return (
    <>
      <TopNav />
      <Sidenav />
      <main className="otp-history">
        <div className="listing__breadcrum">
          <span className="font-14">
            <Link className="op-2" to="/app/admin/dashboard">
              Home/ Dashboard/{" "}
            </Link>
            <span className="c__blue">Recent OTPs</span>
          </span>
        </div>
        <section className="otp-history__panel">
          <div className="otp-history__header">
            <h3>Recent OTPs</h3>
            <p>
              Only the 25 most recently sent registration and password-reset
              OTPs are shown.
            </p>
          </div>
          {message && <p className="otp-history__message">{message}</p>}
          <DataTable
            columns={columns}
            data={otps}
            customStyles={tableStyles}
            highlightOnHover
            progressPending={isLoading}
            noDataComponent="No recent OTPs found."
          />
        </section>
      </main>
    </>
  );
};

export default OtpHistory;
